import Vue from "vue"

export const ScrollingObservable = Vue.observable({
  scrollTop: 0,
  scrollLeft: 0,
  scrollingDown: false,
  scrollingLeft: false,
  scrollingStarted: false,
  passedViewport: false
})